var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 50,
    viewBox: "0 0 33 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5811 41.3655L28.5384 37.043L32.5171 41.3655V44.6565L25.0509 49.1755V46.0318L20.5811 41.3655Z",
    fill: "url(#paint0_linear_220_4282)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5171 41.3655L28.5384 37.043L20.5811 41.3655L25.0509 46.0318M32.5171 41.3655V44.6565L25.0509 49.1755V46.0318M32.5171 41.3655L25.0509 46.0318",
    stroke: "black",
    strokeWidth: 0.196478
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2188 18.1815V0.105469L29.3235 0.694903V16.8552L21.2188 18.1815Z",
    fill: "#D9C063",
    stroke: "black",
    strokeWidth: 0.196478
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0727 0.105469V18.2306L8.5472 18.2797C8.5472 18.2797 7.17142 18.4527 6.72977 19.0165C6.2093 19.6809 6.23858 20.6866 6.23858 20.6866V40.3835L20.5324 41.3168L25.0022 45.9831V49.1759L0.0986328 47.162V0.105469H21.0727Z",
    fill: "#D9C063",
    stroke: "black",
    strokeWidth: 0.196478
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.882 14.4483V1.8246L21.6123 1.43164V15.3325L28.882 14.4483Z",
    fill: "#FBFFEC",
    stroke: "black",
    strokeWidth: 0.196478
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7181 36.5033V18.3291H8.59573C8.59573 18.3291 7.38571 18.4556 6.87654 18.9677C6.3803 19.4667 6.28711 20.5886 6.28711 20.5886V40.3838L15.7181 36.5033Z",
    fill: "url(#paint1_linear_220_4282)",
    stroke: "black",
    strokeWidth: 0.196478
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.44 37.043L15.7181 36.5518L6.28711 40.4322L20.63 41.3164L28.44 37.043Z",
    fill: "url(#paint2_linear_220_4282)",
    stroke: "black",
    strokeWidth: 0.196478
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8329 40.1864L29.9627 41.3161L27.9979 42.5441L26.0331 43.7721L24.8051 42.5441L23.5771 41.3161L25.6402 40.1864L27.7032 39.0566L28.8329 40.1864Z",
    fill: "url(#paint3_radial_220_4282)",
    stroke: "black",
    strokeWidth: 0.196478
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_220_4282",
    x1: 26.5491,
    y1: 37.043,
    x2: 31.5838,
    y2: 44.6565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_220_4282",
    x1: 11.0026,
    y1: 18.3291,
    x2: 11.0026,
    y2: 40.3838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_220_4282",
    x1: 23.7246,
    y1: 39.7445,
    x2: 20.4335,
    y2: 33.2607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_220_4282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.7699 41.4144) rotate(90) scale(2.35774 3.19277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208201,
    stopColor: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410662,
    stopColor: "#C0C6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686404,
    stopColor: "#8F9AE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924112,
    stopColor: "#7281DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4155D3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachine);
export default __webpack_public_path__ + "static/media/machine.7b72fa472a1570ddfa8f341d53f37126.svg";
export { ForwardRef as ReactComponent };